define('lib/audio/construct-local-audio',['require','lodash','lib/audio/create-localized-country','lib/audio/audio-default-countries','lib/audio/audio-default-countries-call-me'],function (require) {
    var _ = require('lodash');
    var createLocalizedCountry = require('lib/audio/create-localized-country');
    var audioDefaultCountries = require('lib/audio/audio-default-countries');
    var audioDefaultCountriesCallMe = require('lib/audio/audio-default-countries-call-me');

    function isAllowed(settings, mode) {
        return _.includes(settings.allowedModes, mode);
    }

    function isDefault(settings, mode) {
        return _.includes(settings.defaultModes, mode);
    }

    return function (originalApiAudio, otherSettings) {
        var apiAudio = _.cloneDeep(originalApiAudio);
        var billingCountry = otherSettings ? otherSettings.billingCountry : '';
        var localAudio = {};

        if (isAllowed(apiAudio, 'VOIP')) {
            localAudio.isVoip = isDefault(apiAudio, 'VOIP');
        }

        if (isAllowed(apiAudio, 'DIALOUT')) {
            localAudio.isDialOut = isDefault(apiAudio, 'DIALOUT');

            if (otherSettings.isDialOutInternationalEnabled && apiAudio.defaultDialOutCountries && apiAudio.allowedDialOutCountries) {
                localAudio.dialOutCountries = audioDefaultCountriesCallMe(
                    apiAudio.defaultDialOutCountries,
                    apiAudio.allowedDialOutCountries
                ).map(function (countryCode) {
                    return createLocalizedCountry(countryCode);
                });
            } else {
                localAudio.dialOutCountries = [];
            }
        }

        if (isAllowed(apiAudio, 'TOLL')) {
            localAudio.isToll = isDefault(apiAudio, 'TOLL');

            localAudio.tollCountries = audioDefaultCountries(
                apiAudio.defaultTollCountries,
                apiAudio.allowedTollCountries,
                billingCountry
            ).map(function (countryCode) {
                return createLocalizedCountry(countryCode);
            });

            localAudio.preferredTollCountry = createLocalizedCountry(apiAudio.preferredTollCountry);
        }

        if (isAllowed(apiAudio, 'TOLLFREE')) {
            localAudio.isTollFree = isDefault(apiAudio, 'TOLLFREE');

            localAudio.tollFreeCountries = audioDefaultCountries(
                apiAudio.defaultTollFreeCountries,
                apiAudio.allowedTollFreeCountries,
                billingCountry
            ).map(function (countryCode) {
                return createLocalizedCountry(countryCode);
            });

            localAudio.preferredTollFreeCountry = createLocalizedCountry(apiAudio.preferredTollFreeCountry);
        }

        if (isAllowed(apiAudio, 'PRIVATE')) {
            var builtInAudio = localAudio.isVoip || localAudio.isToll || localAudio.isTollFree || localAudio.isDialOut;
            localAudio.isPrivate = isDefault(apiAudio, 'PRIVATE') && !builtInAudio;
            localAudio.privateMessage = apiAudio.defaultModeratorPrivateMessage;
        }

        return localAudio;
    };
});

